const client_id = 'client';
const client_secret = 'secret';
const basicAuthToken = `${client_id}:${client_secret}`;
const hash = btoa(basicAuthToken);
const BASIC_AUTH_TOKEN = `Basic ${hash}`;

export default BASIC_AUTH_TOKEN;
